import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import * as Global from "../styles/Global";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
} from "../styles/Global";
import moment from "moment";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import loading from "react-useanimations/lib/loading";
import UseAnimations from "react-useanimations";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { BiRefresh } from "react-icons/bi";
import { IoIosArrowDropupCircle } from "react-icons/io";
import { IoMdRemoveCircleOutline } from "react-icons/io";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsFilterRight } from "react-icons/bs";

function TournamentsFilterOptions({
  openFilter,
  format,
  setFormat,
  customFilter,
  generation,
  setGeneration,
  tableValue,
  dateRange,
  setDateRange,
  setUpcomingFilter,
  getRowData,
  dataCallBody,
  setPastFilter,
  setOpenFilter,
  tableType,
  seasonOptions,
  setSeasonOptions,
}) {
  return (
    <>
      <FlexRow
        style={{
          padding: "15px 0",
          width: "100%",
        }}
      >
        <FormControl
          fullWidth
          style={{
            marginRight: 10,
          }}
        >
          <InputLabel id="demo-simple-select-label">Format</InputLabel>
          <Select
            labelId="game-type-select-label"
            id="game-type-select"
            value={format}
            label="Format"
            onChange={(e) => {
              console.log("event: ", e);
              setFormat(e.target.value);
              customFilter(e.target.value, "select", "format");
            }}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Round Robin">Round Robin</MenuItem>
            <MenuItem value="Single Elimination">Single Elimination</MenuItem>
            <MenuItem value="Double Elimination">Double Elimination</MenuItem>
            <MenuItem value="Pool Play">Pool Play</MenuItem>
            <MenuItem value="Set Schedule">Set Schedule</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Generation</InputLabel>
          <Select
            labelId="generation-select-label"
            id="generation-select"
            value={generation}
            label="Generation"
            onChange={(e) => {
              console.log("event: ", e);
              setGeneration(e.target.value);
              customFilter(e.target.value, "select", "teamCreate");
            }}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Singles">Singles</MenuItem>
            <MenuItem value="Set Teams">Set Teams</MenuItem>
            <MenuItem value="Blind Draw">Blind Draw</MenuItem>
            <MenuItem value="Squadholio">Squadholio</MenuItem>
            <MenuItem value="Switcholio">Switcholio</MenuItem>
            <MenuItem value="Split Switch">Split Switch</MenuItem>
          </Select>
        </FormControl>
      </FlexRow>
      <FlexRow
        style={{
          padding: "15px 0",
          width: "100%",
        }}
        align="center"
        justify="flex-end"
      >
        {tableType === "current" || tableType === 0 ? (
          <FormControl
            style={{
              marginRight: 10,
            }}
            fullWidth
          >
            <InputLabel id="date-range-label">Date Range</InputLabel>
            <Select
              labelId="range-select-label"
              id="range-select"
              value={dateRange}
              label="Date Range"
              onChange={(e) => {
                console.log("event: ", e);
                setDateRange(e.target.value);
                setUpcomingFilter(e.target.value);
                getRowData({ ...dataCallBody, range: e.target.value });
              }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Today">Today</MenuItem>
              <MenuItem value="Yesterday">Yesterday</MenuItem>
              {/* <MenuItem value="Tomorrow">Tomorrow</MenuItem> */}
              <MenuItem value="This Week">This Week</MenuItem>
              <MenuItem value="Next Week">Next Week</MenuItem>
            </Select>
          </FormControl>
        ) : tableType === "past" ? (
          <FormControl
            style={{
              marginRight: 10,
            }}
            fullWidth
          >
            <InputLabel id="date-range-label">Date Range</InputLabel>
            <Select
              labelId="range-select-label"
              id="range-select"
              value={dateRange}
              label="Date Range"
              onChange={(e) => {
                console.log("event: ", e);
                setDateRange(e.target.value);
                setPastFilter(e.target.value);
                getRowData({ ...dataCallBody, range: e.target.value });
              }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Last Week">Last Week</MenuItem>
              <MenuItem value="Last Month">Last Month</MenuItem>
              <MenuItem value="Last Year">Last Year</MenuItem>
            </Select>
          </FormControl>
        ) : null}
        {/* <FormControl fullWidth>
          <InputLabel id="date-range-label">Seasons</InputLabel>
          <Select
            labelId="seasons-select-label"
            id="seasons-select"
            value={seasonOptions}
            label="Seasons"
            onChange={(e) => {
              console.log("event: ", e);
              setSeasonOptions(e.target.value);
              getRowData({ ...dataCallBody, season: e.target.value });
            }}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Submitted">Submitted</MenuItem>
            <MenuItem value="Unsubmitted">Unsubmitted</MenuItem>
            <MenuItem value="Unassigned">Unassigned</MenuItem>
          </Select>
        </FormControl> */}
      </FlexRow>
      <FlexRow style={{ width: "100%" }} justify="flex-end" align="center">
        <IoIosArrowDropupCircle
          onClick={() => setOpenFilter(false)}
          size={40}
          color={Global.red}
          style={{
            marginLeft: 10,
            cursor: "pointer",
          }}
        />
      </FlexRow>
    </>
  );
}

export default TournamentsFilterOptions;
